import Auth from "@/components/pages/authEmbed/Index";

import LoginForm from "@/components/pages/authEmbed/Login";

import Register from "@/components/pages/authEmbed/register/Index";
import RegistrationCompleteEmail from "@/components/pages/auth/complete/Email";

import PasswordRemind from "@/components/pages/authEmbed/password/remind/Index";

import AccountLocked from "@/components/pages/auth/Locked";

import * as pages from "./../pageNameConstants";

export default {
  path: "/auth-embed",
  component: Auth,
  children: [
    {
      path: "",
      name: pages.AUTH_EMBED_LOGIN,
      component: LoginForm
    },
    {
      path: "register",
      name: pages.AUTH_EMBED_REGISTER,
      component: Register
    },
    {
      path: "register/complete",
      name: pages.AUTH_EMBED_REGISTER_COMPLETE,
      component: RegistrationCompleteEmail
    },
    {
      path: "password/reminder",
      name: pages.AUTH_EMBED_PASSWORD_REMINDER,
      component: PasswordRemind
    },
    {
      path: "locked",
      name: pages.AUTH_EMBED_LOCKED,
      component: AccountLocked
    }
  ]
};
